export default __webpack_public_path__ + "static/media/avatar.a2d77d58.jpeg";